import React, {useState} from 'react';
import axios from "axios";
import WeatherInfo from './WeatherInfo';
import WeatherForecast from './WeatherForecast';
import "./Weather.css";


export default function Weather(props) {
    const [weatherData, setWeatherData] = useState({ready:false});
    const [city, setCity] = useState(props.defaultCity);

    function handleResponse(response) {
        
        setWeatherData( {
            ready: true,
            coordinates: response.data.coord,
            temperature: response.data.main.temp,
            date: new Date(response.data.dt * 1000),
            city: response.data.name,
            description: response.data.weather[0].description,
            wind: response.data.wind.speed,
            humidity: response.data.main.humidity,
            pressure: response.data.main.pressure,
            iconUrl: `https://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`
    });
    
    }

    function handleSubmit(event) {
         event.preventDefault();
         search();
    }

    function handleCityChange(event){
        setCity(event.target.value);
    }
    function search() {
        const apiKey = "09d7fe078a1bda5730bd116188593f4a";
        let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
        axios.get(apiUrl).then(handleResponse);
    }

    if (weatherData.ready) {
        return (
            <div className='weather'>
    
                <form onSubmit={handleSubmit}>
                    <div className='row'>
    <div className='col-sm-10'>
    <input type="search"
    placeholder='Enter a city...'
    className='searchInput'
    autoFocus="on"
    onChange={handleCityChange}
    />
    </div>
    <div className='col-sm-2'>
    <input type="submit"
    value= 'search'
    className='button'
    />
    </div>
                    </div>
                </form>
                <WeatherInfo data={weatherData} />
                <WeatherForecast coordinates={weatherData.coordinates} />
                </div>
        );
    } else {
    search();
    return "Loading...";
    }
    }